import vendor from "@/services/operativos/vendor";
import { Model } from "vue-mc";

export class Rep extends Model {
  defaults() {
    return {
      clave: null
      , code: null
      , nombre: ""
      , apellido: ""
      , tipo: ""
      , status: true
      , vendor: []
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , code: (code) => code
      , nombre: (nombre) => nombre
      , apellido: (apellido) => apellido
      , tipo: (tipo) => tipo
      , status: (status) => status
      , vendor: (vendor) => vendor
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/rep.js